import React, { useState } from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "../../../component/SnackbarContext";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import { TiPlusOutline } from "react-icons/ti";

function ServicesSettigs({ onClose , onSubmit }) {
  const [addValues, setAddValues] = useState([]);
  const [selectedValue, setSelecedValue] = useState("");

  const handleSubmit = async () => {
     onSubmit(addValues)
  };

  const handleChange = (value) => {
    if (value) {
      setSelecedValue(value);
    } else {
      setSelecedValue("");
    }
  };


  const handleAdd = () => {
     const trimmedValue = selectedValue?.trim();
    if (trimmedValue) {
       setAddValues((prev) => {
        if (!prev.includes(trimmedValue)) {
          return [...prev, trimmedValue];
        }
        return prev;
      });
       setSelecedValue("");
    } 
  };
  

  return (
    <div className="pt-6 px-10">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">Add Dropdown Values</div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="flex flex-col my-4 w-full justify-center items-center">
        <div className="flex gap-2 w-full items-center">
          <TextFieldCustom
            label="Add values"
            value={selectedValue}
            onChange={(e) => handleChange(e.target.value)}
            fullWidth
          />
          <button
            onClick={handleAdd}
            className="flex justify-center items-center w-[50px] !h-[45px] !rounded-full !bg-[#3383B2] !text-white hover:!bg-[#2a6c94]"
          >
            <TiPlusOutline size={20} />
          </button>
        </div>

          {addValues.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-4 w-full  text-sm">
              {addValues.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full border border-blue-300"
                >
                  {item}
                  <button
                    className="text-blue-600 hover:text-red-500 ml-2"
                    onClick={() =>
                      setAddValues((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
        )}

        <div className="flex flex-col sm:flex-row justify-center items-center mt-8 mb-4 gap-3">
       
          <CustomButton
            onClick={handleSubmit}
             disabled={addValues.length <= 0}
              customeClass={`gradient-button w-[200px] h-[40px] ${
                addValues.length <= 0 ? "opacity-60 cursor-not-allowed" : ""
              }`}
          >
            Submit
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default ServicesSettigs;
